/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurationDto } from './ConfigurationDto';
import {
    ConfigurationDtoFromJSON,
    ConfigurationDtoFromJSONTyped,
    ConfigurationDtoToJSON,
    ConfigurationDtoToJSONTyped,
} from './ConfigurationDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface ConfigurationResponse
 */
export interface ConfigurationResponse {
    /**
     * 
     * @type {ConfigurationDto}
     * @memberof ConfigurationResponse
     */
    data?: ConfigurationDto;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof ConfigurationResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof ConfigurationResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof ConfigurationResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the ConfigurationResponse interface.
 */
export function instanceOfConfigurationResponse(value: object): value is ConfigurationResponse {
    return true;
}

export function ConfigurationResponseFromJSON(json: any): ConfigurationResponse {
    return ConfigurationResponseFromJSONTyped(json, false);
}

export function ConfigurationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ConfigurationDtoFromJSON(json['data']),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function ConfigurationResponseToJSON(json: any): ConfigurationResponse {
    return ConfigurationResponseToJSONTyped(json, false);
}

export function ConfigurationResponseToJSONTyped(value?: ConfigurationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ConfigurationDtoToJSON(value['data']),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

